import {Icon} from '@/components/atoms'
import {useState} from 'react'
import {Link, useLocation} from 'react-router-dom'

const SidebarMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const currentPagePath = useLocation().pathname

  const toggleMenu = () => {
    setIsOpen(state => !state)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  const menuItems = [
    // {
    //   path: ROUTES.LIST_NBAS,
    //   label: formatMessage({id: 'SIDEBAR.NBAS'}),
    //   icon: props => <Icon data-testid="menu-nbas-list" icon={'fact_check'} {...props} />,
    //   enabled: () => true,
    // },
    // {
    //   path: ROUTES.NBA_REPORTS,
    //   label: formatMessage({id: 'SIDEBAR.REPORTS'}),
    //   icon: props => <Icon data-testid="menu-reports" icon={'text_snippet'} {...props} />,
    //   enabled: () => true,
    //   optionalPath: ROUTES.TASK_REPORTS,
    // },
    // {
    //   path: ROUTES.EVENTS,
    //   label: formatMessage({id: 'SIDEBAR.EVENTS'}),
    //   icon: props => <Icon data-testid="menu-events" icon={'account_tree'} {...props} />,
    //   enabled: () => false,
    // },
    // {
    //   path: ROUTES.SETTINGS,
    //   label: formatMessage({id: 'SIDEBAR.SETTINGS'}),
    //   icon: props => <Icon data-testid="menu-settings" icon={'settings'} {...props} />,
    //   enabled: () => false,
    // },
  ]

  return (
    <>
      <nav
        data-testid="side-menu"
        className={`shadow-lg absolute z-10 flex h-full flex-col bg-layer-01 ${isOpen ? 'w-64' : 'w-20'}`}
      >
        {!isOpen && (
          <div
            className="mb-4 flex h-14 w-full cursor-pointer items-center pl-8"
            title="Open menu"
            onClick={toggleMenu}
          >
            <Icon icon={'menu'} className="text-text-primary hover:text-text-black" />
          </div>
        )}
        {isOpen && (
          <div className="mb-4 flex h-14 w-full items-center pl-8 pr-4" title="Close menu">
            <Icon
              icon={'menu'}
              size="medium"
              className="cursor-pointer text-text-primary hover:text-text-black"
              onClick={closeMenu}
            />
            <span className="cursor-pointer pl-4 text-text-primary hover:text-text-black" onClick={closeMenu}>
              Menu
            </span>
          </div>
        )}

        <ul className="flex h-full w-full flex-col gap-4">
          {menuItems
            .filter(item => item.enabled())
            .map((item, idx) => {
              const isSelected = currentPagePath === item.path || currentPagePath == item.optionalPath

              return (
                <li
                  key={`${idx}_${item.path}`}
                  className={`flex ${
                    isSelected
                      ? 'to-none bg-gradient-to-r from-link from-[5px] to-[5px] text-link hover:bg-layer-01-hover'
                      : 'text-text-secondary hover:bg-layer-02'
                  }`}
                >
                  <Link to={item.path} className={`flex w-full cursor-pointer gap-4 py-2 pl-8`} onClick={closeMenu}>
                    <span data-cy={`${item.label}-sidebar-option`} className="flex w-6 justify-center">
                      {item.label}
                    </span>
                    <span className={`${isOpen ? 'flex' : 'hidden'} flex-1`}> {item.label}</span>
                  </Link>
                </li>
              )
            })}
        </ul>
      </nav>
      {isOpen && <div className="absolute z-[9] h-screen w-screen cursor-default bg-gray-400/60" onClick={closeMenu} />}
    </>
  )
}

export default SidebarMenu
